var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13.571 32",
    preserveAspectRatio: "xMinYMin meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "bulb",
    fill: "#FED843",
    cx: 6.606,
    cy: 25.794,
    r: 2.058
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#676789",
    d: "M6.307,19.07h0.77V0h-0.77V19.07z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ray",
    fill: "#FED843",
    d: "M5.962,29.292h1.017v2.505H5.962V29.292z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ray",
    fill: "#FED843",
    d: "M1.306,30.432L0.467,29.85l1.428-2.055l0.839,0.581L1.306,30.432z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ray",
    fill: "#FED843",
    d: "M11.768,30.57l-1.431-2.051l0.836-0.59l1.431,2.06L11.768,30.57z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5656FC",
    d: "M6.662,16.77c6.69,0,6.634,9.041,6.634,9.041H0.031C0.031,25.811-0.024,16.77,6.662,16.77z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#396CEE",
    d: "M6.662,25.811h6.634c0,0,0.056-9.041-6.634-9.041"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#89A9FD",
    d: "M6.662,25.811H0.031c0,0-0.056-9.041,6.634-9.041"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.a375778df6f87fdcf659856de9c7c750.svg";
export { ForwardRef as ReactComponent };